import React from 'react';
import { CHOOSE_CLASS, PREVIEW_HEADING_CLASS } from './FileInputClasses';
import translations from './translations';

const PreviewHeading = ({
  files,
  language = 'en',
}: {
  files: FileList | null;
  language?: 'en' | 'es';
}): JSX.Element | null => {
  if (!files) {
    return null;
  }
  const {
    multipleFilesSelectedLabel,
    changeMultipleFilesLabel,
    singleFileSelectedLabel,
    changeSingleFileLabel,
  } = translations[language];
  return (
    <div className={PREVIEW_HEADING_CLASS}>
      {files.length > 1 ? (
        <>
          {files.length} {multipleFilesSelectedLabel} <span className={CHOOSE_CLASS}>{changeMultipleFilesLabel}</span>
        </>
      ) : (
        <>
          {singleFileSelectedLabel} <span className={CHOOSE_CLASS}>{changeSingleFileLabel}</span>
        </>
      )}
    </div>
  );
};

export default PreviewHeading;
